/** Public paths under `public/` (served as site root). */
export const SCREENSHOT_SRC = {
  editor: "/images/screenshot-editor.png",
  control: "/images/screenshot-control.png",
  presentation: "/images/screenshot-presentation.png",
  atmosphere: "/images/screenshot-effects.png",
} as const;

/** Pixel size of `screenshot-effects.png` (do not upscale beyond this). */
export const EFFECTS_SCREENSHOT_INTRINSIC = {
  width: 294,
  height: 314,
} as const;

/** Show effects screenshot at 70% of intrinsic pixels (−30%). */
export const EFFECTS_SCREENSHOT_DISPLAY_SCALE = 0.7;

export function getEffectsScreenshotDisplaySize(): {
  width: number;
  height: number;
} {
  return {
    width: Math.round(
      EFFECTS_SCREENSHOT_INTRINSIC.width * EFFECTS_SCREENSHOT_DISPLAY_SCALE,
    ),
    height: Math.round(
      EFFECTS_SCREENSHOT_INTRINSIC.height * EFFECTS_SCREENSHOT_DISPLAY_SCALE,
    ),
  };
}
